export default __webpack_public_path__ + "img/feature_choose_reward.b075962a.svg";